const FeatureFilterEnum = {
  Alerting    : 'Alerting',
  Hedging     : 'Hedging',
  LivePrice   : 'LivePrice',
  Position    : 'Position',
  RiskAnalysis: 'RiskAnalysis'
}

export default FeatureFilterEnum
